import React from "react";
import { applySpec } from "ramda";
import { connect } from "react-redux";
import { getDownloadFileName, getDownloadLink, getTitle } from "util/mediaUtil";
import MediaAvatar from "components/MediaAvatar";
import MediaIcon from "components/MediaIcon";
import MediaLinkDark from "application/components/MediaLinkDark";
import { Link } from "react-toolbox/lib/link";
import {getEditMediaOriginalMediaItem, getThumbnailDialogProcessing} from "common/selectors";
import styles from "edit-media/components/EditMediaHeader.css";
import linkTheme from "application/components/MediaLinkDarkTheme.css";
import ProgressBar from 'react-toolbox/lib/progress_bar';

const EditMediaHeader = ({ mediaItem, thumbnailProcessing }) => (
  <div className={styles.container}>
    {thumbnailProcessing ?
      <div className={styles.thumbnailProcessing}>
        <ProgressBar
          type="circular"
          mode="indeterminate"
        />
      </div>
      :
      <MediaAvatar className={styles.avatar} media={mediaItem}>
        <MediaIcon className={styles.mediaIcon} media={mediaItem}/>
      </MediaAvatar>
    }
    <div className={styles.titleContainer}>
      <div className={styles.title}>
        <div>{getTitle(mediaItem)}</div>
        {getDownloadLink(mediaItem) ? (
          <Link
            href={getDownloadLink(mediaItem)}
            target="_blank"
            active
            download={getDownloadFileName(mediaItem)}
            theme={linkTheme}
            icon="vertical_align_bottom"
          />
        ) : (
          <div />
        )}
      </div>
      <div className={styles.mediaId}>{mediaItem.id}</div>
    </div>
    <div className={styles.contentLink}>
      <MediaLinkDark
        media={mediaItem}
        label="Open In BiblioBoard"
        icon="arrow_forward"
        active
      />
    </div>
  </div>
);

const mapStateToProps = applySpec({
  mediaItem: getEditMediaOriginalMediaItem,
  thumbnailProcessing: getThumbnailDialogProcessing,
});

export default connect(mapStateToProps)(EditMediaHeader);
